// KWANKGM04030_借入申込入力（確認）
// KWANKGM04120_農業資金借入申込入力（確認）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ShelfInfoObj, SetShelfInfo } from '../../types/FileUpload';
import FooterBorrowingApplicationInputConfirmation from '../../organisms/FooterBorrowingApplicationInputConfirmation';
import FileUpload from '../../templates/FileUpload';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';

interface Props {
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  is_loading: boolean;
  reception_cd: string;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  step_navigation: StepType;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  is_change: boolean;
  movePrevStep: () => void;
  moveNextStep: () => void;
  handleClickChangeDetails: () => Promise<any>;
  handleClickDecline: () => Promise<any>;
  handleClickNext: () => Promise<any>;
  handleClickTempSave: () => Promise<any>;
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  show_error_nav: boolean;
  display_status: boolean;
  setDisplayStatus: (flag: boolean) => void;
  callApi: (function_name: string) => Promise<any>;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  is_secured:boolean;
  is_unsecured:boolean;
  is_agricultural_modernization_funds:boolean;
}

const ExaminationFinalConfirm: React.FC<Props> = ({
  step_navigation,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  is_loading,
  looks_inactive,
  shelf_info,
  setShelfInfo,
  reception_id,
  reception_cd,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  status_code,
  is_change,
  movePrevStep,
  moveNextStep,
  handleClickChangeDetails,
  handleClickDecline,
  handleClickNext,
  handleClickTempSave,
  guarantors_num,
  guarantor_info,
  show_error_nav,
  display_status,
  setDisplayStatus,
  callApi,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <FooterBorrowingApplicationInputConfirmation
        is_change={is_change}
        movePrevStep={movePrevStep}
        handleClickChangeDetails={handleClickChangeDetails}
        handleClickDecline={handleClickDecline}
        handleClickNext={handleClickNext}
        handleClickTempSave={handleClickTempSave}
        reception_cd={reception_cd}
        reception_id={reception_id}
        moveNextStep={moveNextStep}
        setDisplayStatus={setDisplayStatus}
        status_code={status_code}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ExaminationFinalConfirm;
